module.exports = __webpack_public_path__ + "media/images/success-2-49b6896cd502bfefb173de03da2e777d.png";